const Menu =  [
  {
    title: 'Dashboard',
    icon: 'dashboard',
    name: 'Dashboard',
  },
  {
    title: 'Banners',
    icon: 'photo_library',
    name: 'Banners',
  },
  {
    title: 'Cidades',
    icon: 'location_city',
    name: 'Cidades',
  },
  {
    title: 'Imóveis',
    icon: 'store_mall_directory',
    name: 'Imoveis',
  },
  {
    title: 'Tipos de Imóveis',
    icon: 'menu',
    name: 'TiposImoveis',
  },
  {
    title: 'Slider TV',
    icon: 'photo_library',
    name: 'SlidersTV',
  },
  {
    title: 'Usuários',
    icon: 'person',
    name: 'Usuarios',
  },

  // {
  //   title: 'Widgets',
  //   group: 'widgets',
  //   component: 'widgets',
  //   icon: 'widgets',
  //   items: [
  //     { name: 'social', title: 'Social', component: 'components/social' },
  //     { name: 'statistic', title: 'Statistic', badge: 'new', component: 'components/statistic' },
  //     { name: 'chart', title: 'Chart', component: 'components/chart' },
  //     { name: 'list', title: 'List', component: 'components/widget-list' },
  //     // { name: 'post', title: 'Post', component: 'components/widget-post' },
  //   ]
  // },
];
// reorder menu
Menu.forEach((item) => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }
});

export default Menu;



// WEBPACK FOOTER //
// ./src/menu.js